import React from "react";
import { Router, Route, Switch, Redirect } from "react-router-dom";
import { PrivateRoute } from "./PrivateRoute";
import { history } from "@_utils/helpers";
import { routeConstants } from "@_constants/route.constants.js";
import Layout from "@_pages/Layout/Layout";

function RouteWrapper({ component: Component, layout: Layout, ...rest }) {
  return (
    <Route
      {...rest}
      render={(props) => (
        <Layout {...props}>
          <Component {...props} />
        </Layout>
      )}
    />
  );
}

function Routes() {
  return (
    <Router history={history}>
      <Switch>
        {routeConstants.PUBLIC_ROUTES.map((route) => (
          <RouteWrapper
            key={route.path.toString()}
            path={route.path}
            component={route.component}
            layout={Layout}
          />
        ))}

        <Layout>
          <Switch>
            {routeConstants.PRIVATE_ROUTES.map((route) => (
              <PrivateRoute
                key={route.path}
                exact={route.exact}
                path={route.path}
                component={route.component}
              />
            ))}
            <Redirect from="*" to="/page_not_found" />
          </Switch>
        </Layout>
      </Switch>
    </Router>
  );
}

export default Routes;
